import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Rows from "../../../../../components/pagination/rows";
import Pagination from "../../../../../components/pagination";
import {
  SetActivePAGE,
  SetMaxPage,
} from "../../../../../services/redux/slices/market/machines";
const Footer = () => {
  const { isLoading, totalPages, activePage } = useSelector(
      ({ machines }) => machines
    ),
    { maxPage } = useSelector(({ auth }) => auth),
    dispatch = useDispatch();

  useEffect(() => {
    dispatch(SetMaxPage(maxPage));
  }, [dispatch, maxPage]);

  const handlePageChange = (action) => {
    const newPage =
      typeof action === "number" ? action : activePage + (action ? 1 : -1);
    if (newPage >= 1 && newPage <= totalPages) {
      dispatch(SetActivePAGE(newPage));
    }
  };

  return (
    <div className="mb-auto d-flex justify-content-between align-items-center px-4">
      <Rows disablePageSelect={false} />
      <Pagination
        isLoading={isLoading}
        total={totalPages}
        page={activePage}
        setPage={handlePageChange}
      />
    </div>
  );
};

export default Footer;
